import { useSelector } from "react-redux";
import { validarQueTengaAunqueSeaUnSoloPermiso, validarSoloUnPermiso } from "../../../helpers/permisos";
import { GenericBreadcrumb } from "../../atomic/organisms/GenericBreadcrumb"
import { TOTEM_BASIC_PERMISOS } from "../../../utils/permisos";
import { Inbox, Search } from "@material-ui/icons";
import { BandejaTotemBasic } from "./components/BandejaTotemBasic";
import { BoxesTomados } from "./components/BoxesTomados";
import { useTotemBasic } from "../../../hooks/useCases/useTotemBasic";

export const GestionTotemBasic = () => {
  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { get } = useTotemBasic()
  return (
    <GenericBreadcrumb
      breads={[
        {
          text: "Gestion de Solicitudes",
          Icon: <Search />,
          filter: validarSoloUnPermiso(permisosUser, TOTEM_BASIC_PERMISOS.RECEPCION.GESTION_SOLICITUDES),
          Component: (
            <BandejaTotemBasic />
          ),
          onClick: () => {
            get.opciones()
            get.boxesTomados()
          }
        },
        {
          text: "Selección de Box",
          Icon: <Inbox />,
          filter: !validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [TOTEM_BASIC_PERMISOS.ADMINISTRAR.LIBERAR_BOXES, TOTEM_BASIC_PERMISOS.RECEPCION.SELECCION_BOX]),
          Component: (
            <BoxesTomados />
          )
        }
      ]}
    />)
}
